"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const lucide_vue_next_1 = require("lucide-vue-next");
const Loader_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/Loader.vue"));
let ClusterEditorSavedList = class ClusterEditorSavedList extends vue_property_decorator_1.Vue {
    async loadSavedClusters() {
        await this.saved_cluster_list.load(this.parcels, this.numClusters, this.sampleDisabledFn);
    }
    loadSavedCluster(savedCluster) {
        this.$emit('loadSavedCluster', savedCluster);
        // @ts-ignore
        window.mixpanel.track('Loaded Saved Cluster');
    }
    async deleteSavedCluster(savedCluster) {
        await savedCluster.delete();
        await this.loadSavedClusters();
        // @ts-ignore
        window.mixpanel.track('Deleted Saved Cluster');
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClusterEditorSavedList.prototype, "parcels", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClusterEditorSavedList.prototype, "numClusters", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClusterEditorSavedList.prototype, "saved_cluster_list", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], ClusterEditorSavedList.prototype, "sampleDisabledFn", void 0);
ClusterEditorSavedList = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Loader: Loader_vue_1.default,
            ArrowRight: lucide_vue_next_1.ArrowRight
        }
    })
], ClusterEditorSavedList);
exports.default = ClusterEditorSavedList;
